import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2213f108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__student-detail pb-30" }
const _hoisted_2 = { class: "__goal-management-student-detail p-10 md-down:px-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }
const _hoisted_5 = { class: "__breadcrumbs__decorate" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-2 text-neutral-400"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_7 = { class: "__goal-management-student-detail__header pt-5" }
const _hoisted_8 = { class: "flex justify-between items-center w-full" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "font-medium leading-none text-white text-4xl" }
const _hoisted_13 = {
  key: 2,
  class: "absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 h-14 w-14 rounded-full flex items-center justify-center",
  style: {"background-color":"rgba(\n\t\t\t\t\t\t\t\t\t\t\t241,\n\t\t\t\t\t\t\t\t\t\t\t162,\n\t\t\t\t\t\t\t\t\t\t\t103,\n\t\t\t\t\t\t\t\t\t\t\t0.5\n\t\t\t\t\t\t\t\t\t\t)"}
}
const _hoisted_14 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.4615 7.00011C13.4615 10.5687 10.5686 13.4617 6.99999 13.4617C3.43138 13.4617 0.538452 10.5687 0.538452 7.00011C0.538452 3.4315 3.43138 0.538574 6.99999 0.538574C10.5686 0.538574 13.4615 3.4315 13.4615 7.00011ZM6.99999 3.3655C6.99999 3.14246 6.81918 2.96165 6.59614 2.96165C6.37311 2.96165 6.1923 3.14246 6.1923 3.3655V7.80781C6.1923 7.95273 6.26995 8.08654 6.39578 8.15844L9.2227 9.77383C9.41636 9.88449 9.66305 9.81721 9.7737 9.62355C9.88436 9.4299 9.81708 9.18321 9.62343 9.07255L6.99999 7.57344V3.3655Z",
  fill: "white"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.56127 3.76863C4.43858 3.76863 4.32255 3.8244 4.24592 3.9202L1.78255 6.9994H5.38461C5.60765 6.9994 5.78845 7.18021 5.78845 7.40325C5.78845 8.07236 6.33088 8.61478 6.99999 8.61478C7.66911 8.61478 8.21153 8.07236 8.21153 7.40325C8.21153 7.18021 8.39234 6.9994 8.61538 6.9994H12.2174L9.75407 3.9202C9.67743 3.8244 9.5614 3.76863 9.43872 3.76863H4.56127ZM3.61521 3.41563C3.84513 3.12824 4.19322 2.96094 4.56127 2.96094H9.43872C9.80676 2.96094 10.1549 3.12824 10.3848 3.41563L13.373 7.15096C13.4411 7.2361 13.4719 7.34515 13.4584 7.45334L13.143 9.9766C13.0672 10.5829 12.5518 11.0379 11.9408 11.0379H2.05916C1.44816 11.0379 0.932766 10.5829 0.85698 9.9766L0.541572 7.45334C0.52805 7.34515 0.558842 7.2361 0.626949 7.15096L3.61521 3.41563Z",
  fill: "white"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  fill: "none",
  height: "14",
  viewBox: "0 0 40 40",
  width: "14",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z",
  fill: "#FAF5F1",
  "fill-rule": "evenodd"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "ml-4" }
const _hoisted_24 = { class: "font-bold text-neutral-700 text-4xl md-down:text-2xl" }
const _hoisted_25 = {
  key: 0,
  class: "text-green-500 font-semibold text-xs uppercase"
}
const _hoisted_26 = {
  key: 1,
  class: "text-green-500 font-semibold text-xs uppercase"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "flex space-x-4" }
const _hoisted_30 = { class: "mt-10" }
const _hoisted_31 = { class: "border-b border-neutral-200 md-down:hidden" }
const _hoisted_32 = {
  class: "-mb-px flex space-x-8 tabs overflow-auto",
  "aria-label": "Tabs"
}
const _hoisted_33 = ["data-tour-id"]
const _hoisted_34 = { class: "md:hidden" }
const _hoisted_35 = { class: "p-6 bg-white select-tabs" }
const _hoisted_36 = { class: "flex flex-nowrap items-center" }
const _hoisted_37 = { class: "flex flex-nowrap items-center font-medium" }
const _hoisted_38 = { class: "__goal-management-student-detail__overview px-10 md-down:px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_TermTooltip = _resolveComponent("TermTooltip")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.is_old_data)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: _ctx.routerName.TRANSFERRED_DATA }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Xem hồ sơ cũ ")
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: _ctx.routerName.PLANS_REPORT }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Kế hoạch ")
                ]),
                _: 1
              }, 8, ["to"])),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DaIcon, {
              name: "das--chevron-down",
              class: "transform -rotate-90 h-3 w-3 mx-2"
            })
          ]),
          _createElementVNode("div", null, "Xem " + _toDisplayString(_ctx.$filters.terminology('plan')), 1)
        ]),
        (_ctx.is_old_data)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args))),
              type: "button",
              class: "button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600"
            }, [
              _hoisted_6,
              _createTextVNode(" Thoát ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: `/record/student/${_ctx.student?.id}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.student?.profile_photo?.w200)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        alt: "",
                        style: {"min-width":"56px"},
                        class: "shadow-sm inline-block h-14 w-14 rounded-full",
                        src: _ctx.student?.profile_photo?.w200
                      }, null, 8, _hoisted_11))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        style: _normalizeStyle([{"min-width":"56px"}, {
										background:
											_ctx.student?.profile_photo?.default
												?.color,
									}]),
                        class: "inline-flex items-center justify-center h-14 w-14 rounded-full"
                      }, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.student?.profile_photo?.default
												?.initial), 1)
                      ], 4)),
                  (_ctx.student?.state !== 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_ctx.student?.state === 'pending')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
                          : (
											_ctx.student?.state === 'archived'
										)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.student?.name), 1),
                  (_ctx.student?.state === 'stopped')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, " XIN NGHỈ "))
                    : _createCommentVNode("", true),
                  (
										_ctx.student?.age &&
										_ctx.student?.state !== 'stopped'
									)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (!_ctx.dateData && !_ctx.is_old_data)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.student?.age) + " " + _toDisplayString(_ctx.student?.learning_time
												? `| ${_ctx.student?.learning_time}`
												: ''), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.dateData), 1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_29, [
            (_ctx.is_old_data)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toDetail && _ctx.toDetail(...args))),
                  type: "button",
                  class: "button-p text-center btn--ghost"
                }, " Xem hồ sơ học sinh "))
              : _createCommentVNode("", true),
            (_ctx.is_old_data)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.viewReport && _ctx.viewReport(...args))),
                  type: "button",
                  class: "button-p text-center btn--ghost"
                }, " Xem báo cáo "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("nav", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.value,
                  class: "flex items-center"
                }, [
                  _createVNode(_component_router_link, {
                    to: {
										name: item.value,
										query: _ctx.queryData,
									},
                    "data-tour-id": item.tourId,
                    class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold",
                    onClick: ($event: any) => (item.onSelect && item.onSelect())
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        "data-tour-id": item.tourLabelId
                      }, _toDisplayString(item.label), 9, _hoisted_33)
                    ]),
                    _: 2
                  }, 1032, ["to", "data-tour-id", "onClick"]),
                  _createVNode(_component_TermTooltip, {
                    text: item.tooltip,
                    label: `Giải thích ${item.label}`
                  }, null, 8, ["text", "label"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tab) = $event)),
                "deselect-label": "Đã chọn",
                "track-by": "value",
                options: _ctx.tabs,
                searchable: true,
                label: "label",
                "allow-empty": false,
                selectLabel: "",
                placeholder: ""
              }, {
                noResult: _withCtx(() => [
                  _createTextVNode(" Không tìm thấy kết quả ")
                ]),
                option: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", null, _toDisplayString(props.option.label), 1)
                  ])
                ]),
                singleLabel: _withCtx(({ option }) => [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", null, _toDisplayString(option.label), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createVNode(_component_router_view)
    ])
  ]))
}